import { State } from '../../../store/state';

export const openedSelector = (state: State) => state.global.opened;
export const foldedSelector = (state: State) => state.global.folded;
export const mobileOpenedSelector = (state: State) => state.global.mobileOpened;
export const dialogsSelector = (state: State) => state.global.dialogs;
